module.exports = __webpack_public_path__ + "img/tab-cover-mobile.9ad60608.svg";